import React from 'react'
import { modals } from '@mantine/modals'
import { Image, Box, Text } from '@mantine/core'
import SearchMascot from '../../../assets/img/mascot/18.png'
import NoImage from '../../../assets/img/images/no-images.png'

export const modalGeneralConfirmation = ({ useCustomImage = false , image, label, name, description, textButton = 'Confirm', onConfirm }) => {
  const handleConfirm = () => {
    onConfirm()
    modals.closeAll()
  }

  return modals.openConfirmModal({
    centered: 'true',
    closeOnConfirm: false,
    withCloseButton: false,
    size: 'lg',
    children: (
      <Box>
        <Box ta='center'>
          {
            useCustomImage
            ? <Image src={image ? image : NoImage} fit='contain' h='180' my={20} />
            : <Image src={SearchMascot} fit='contain' h='180' my={20} />
          }
          <Text fw={500} mb={4}>{label}</Text>
          <Text fw='bold' lineClamp={2} mb={14}>"{name}"</Text>
          <Text fz='sm' c='gray.6' mb={20}>{description}</Text>
        </Box>
      </Box>
    ),
    labels: { confirm: `${textButton}`, cancel: "Cancel" },
    confirmProps: { color: 'red' },
    onConfirm: () => handleConfirm(),
  })
}